import { Component, inject } from '@angular/core';
import { formControl, formGroup, Validators } from '@al00x/forms';
import { AttributeSetEntity } from '@models';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFieldComponent,
} from '@controladad/ng-base';
import { AttributeSetApiService, CategoryApiService } from '../../../services';
import { CategoryTreeComponent } from '../../../components';

export type AttributeSetDialogData = { attributeSet?: AttributeSetEntity };
export type AttributeSetDialogResult = boolean;

@Component({
  selector: 'lib-attribute-set-dialog',
  imports: [CacDialogLayoutComponent, CacFieldComponent, CategoryTreeComponent],
  templateUrl: './attribute-set-dialog.component.html',
  styleUrl: './attribute-set-dialog.component.scss',
})
export class AttributeSetDialogComponent extends CacBaseDialogComponent<
  AttributeSetDialogData,
  AttributeSetDialogResult
> {
  private readonly attributeApi = inject(AttributeSetApiService);
  private readonly categoryApi = inject(CategoryApiService);
  categories$ = this.categoryApi.getAll();

  form = formGroup({
    name: formControl<string>(this.data?.attributeSet?.name, Validators.required),
    categories: formControl<number[]>(this.data?.attributeSet?.categories, Validators.required),
  });

  onSubmit(e: ButtonClickEvent) {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    const id = this.data.attributeSet?.id;
    const values = this.form.getRawValue();

    const request = id ? this.attributeApi.update({ id: id, ...values }) : this.attributeApi.create(values);
    return request.pipe(e.pipe()).subscribe(() => this.submit(true));
  }
}
